/**
* IBM Confidential
* Licensed Materials - Property of IBM
* (C) Copyright IBM Corp. 2020, 2024 All Rights Reserved.
* US Government Users Restricted Rights - Use, duplication or
* disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
* */

import { objectWithoutProperties as _objectWithoutProperties, extends as _extends } from '../../../../../_virtual/_rollupPluginBabelHelpers.js';
import classnames from 'classnames';
import React from 'react';
import PropTypes from 'prop-types';

var _excluded = ["children", "isActive", "isHighlighted"];

/**
 * `ListBoxMenuItem` is a helper component for managing the container class
 * name, alongside any classes for any corresponding states, for a generic list
 * box menu item.
 */
var ListBoxMenuItem = function ListBoxMenuItem(_ref) {
  var children = _ref.children,
    isActive = _ref.isActive,
    isHighlighted = _ref.isHighlighted,
    rest = _objectWithoutProperties(_ref, _excluded);
  var className = classnames({
    'cds--list-box__menu-item': true,
    'cds--list-box__menu-item--active': isActive,
    'cds--list-box__menu-item--highlighted': isHighlighted
  });
  return (
    /*#__PURE__*/
    // eslint-disable-next-line react/jsx-props-no-spreading
    React.createElement("div", _extends({
      className: className
    }, rest), children)
  );
};
ListBoxMenuItem.propTypes = {
  /**
   * Specify any children nodes that hsould be rendered inside of the ListBox
   * Menu Item
   */
  children: PropTypes.node,
  /**
   * Specify whether the current menu item is "active".
   */
  isActive: PropTypes.bool.isRequired,
  /**
   * Specify whether the current menu item is "highlighed".
   */
  isHighlighted: PropTypes.bool.isRequired
};
ListBoxMenuItem.defaultProps = {
  children: undefined
};
var ListBoxMenuItem$1 = ListBoxMenuItem;

export { ListBoxMenuItem$1 as default };
